<template>
    <div class="news-work">
        <el-breadcrumb separator="/" class="bread-crumb main">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>考试指导</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="news-wrapper main examGuidance_box">
            <div class="examGuidance">
                <div class="wary_item_list" v-for="(item, index) in GuideVideolist" :key="index">
                    <div class="imgs" @click="govideo(item.id)">
                        <img class="cover" :src="item.coverPathUrl" v-if="item.coverPathUrl">
                        <img class="cover" src="../../assets/examGuidance/02.png" v-else>
                    </div>
                    <div class="title">{{ item.title }}</div>
                    <div class="info flex-align-between">
                        <span class="teabox">主讲教师：{{ item.speaker }}</span>
                        <span>{{ item.useYear + '-' + item.useMonth }}</span>
                    </div>
                </div>
            </div>
            <div class="block flex-align-center">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
                    :page-sizes="[8, 16, 24, 32]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                    :total="total" background>
                </el-pagination>
            </div>
        </div>
        <footer-view></footer-view>
    </div>
</template>
 
<script>
export default {
    data() {
        return {
            showBtn: true,
            total: null,
            pageNum: 1,
            pageSize: 8,
            GuideVideolist: []

        }
    },
    watch: {
        '$route': function (to, from) {
            document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
            this.showBtn = true;
        }
    },
    methods: {
        handleSizeChange(val) {
            this.pageSize = val
            this.getExamGuidePage();
        },
        handleCurrentChange(val) {
            this.pageNum = val
            this.getExamGuidePage();
        },
        govideo(vid) {
            this.$router.push({
                path: '/list/examGuidanceVideo',
                query: {
                    Id: vid
                }
            });
        },
        async getExamGuidePage() {
            let params = {
                pageSize: this.pageSize,
                pageNum: this.pageNum,
            }
            let resData = await Api.examGuidance.getExamGuidePage(params);
            this.GuideVideolist = resData.rows;
            this.total = resData.total;
        }
    },
    mounted() {
        this.getExamGuidePage();
    },
    destroyed() {
    }
}
</script>
 
<style lang="less" scoped>
@import "./less/news_common.less";
@import "./less/news_headlines.less";

* {
    box-sizing: border-box;
}

.examGuidance_box {
    width: 100%;
    background-color: #f9f9f9;
    padding-top: 30px;
    padding-bottom: 15px;

    .examGuidance {
        width: 1200px;
        margin: 0 auto;
        background-color: #f9f9f9;
        margin-bottom: 30px;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        row-gap: 29px;
        column-gap: 13px;
        min-height: 57vh;

        .wary_item_list {
            background-color: #fff;
            border-radius: 10px;
            width: 290px;
            height: 263px;
            &:hover div{
                color: #CC4C4D;
                cursor: pointer;
            }
            &:hover span{
                color: #CC4C4D;
                cursor: pointer;
            }

            .imgs {
                width: 290px;
                height: 155px;
                border-top-left-radius: 10px;
                border-top-right-radius: 10px;
                position: relative;
                overflow: hidden;
                cursor: pointer;

                .cover {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }

                .tags {
                    width: 50px;
                    height: 34px;
                    position: absolute;
                    top: 0;
                    right: 0;
                }
            }

            .title {
                width: 258px;
                font-size: 15px;
                margin: 16px 12px;
                text-align: justify;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                height: 47px;

            }

            .info {
                margin: 0 12px;
                font-size: 12px;
                color: #999;

                .teabox {
                    width: 190px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;

                    .tea {
                        margin: 0 2px;
                    }
                }
            }
        }
    }

    /deep/.block {
        width: 1200px;
        margin: 0 auto;
        text-align: center;
        margin-bottom: 50px;

        .el-pagination .el-pager .active {
            background-color: #CC4C4D !important;
            color: #fff !important;
        }

        .el-pagination.is-background .el-pager li:hover {
            color: #CC4C4D;
        }

        .el-pager li {
            background-color: #fff;
        }
    }
}</style>